// extracted by mini-css-extract-plugin
export default {"item":"Item_item__h2GeV","dragging":"Item_dragging__ERgac","tagList":"Item_tagList__u3C-K","tag":"Item_tag__Mnhpi","red":"Item_red__2bWCz","green":"Item_green__k40sU"};